import React, {useEffect, useState} from 'react';
import SignIn from './SignIn'
import SignUp from './SignUp'
import ConfirmSignUp from './ConfirmSignUp'
import ForgotPassword from './ForgotPassword'
import ForgotPasswordSubmit from './ForgotPasswordSubmit'
import {signIn, signUp, confirmSignUp, forgotPasswordSubmit, forgotPassword} from '../../auth';
import {H2} from '../ui/Header';
import {Form} from '../ui/Form';
import {useDispatch, useSelector} from 'react-redux';
import {selectMessage, signInUser, userMessageClear} from '../../features/user/userSlice';

const initialFormState = {
  username: '', password: '', email: '', confirmationCode: ''
}

function AuthForm({onSignIn = _ => _}) {
  const [formType, updateFormType] = useState('signIn')
  const [formState, updateFormState] = useState(initialFormState)
  const dispatch = useDispatch()
  const message = useSelector(selectMessage)

  useEffect(() => {
    // Clear any old error messages
    dispatch(userMessageClear())
  }, [dispatch])

  function updateForm(event) {
    const newFormState = {
      ...formState, [event.target.name]: event.target.value
    }
    updateFormState(newFormState)
  }

  const handleSubmit = (callback, event) => {
    event.preventDefault()
    callback()
  }

  function renderForm() {
    switch(formType) {
      case 'signUp':
        return (
          <Form
            method='POST'
            onSubmit={e => handleSubmit(() => signUp(formState, updateFormType), e)}
          >
            <H2>Sign Up</H2>
            <SignUp
              updateFormState={e => updateForm(e)}
            />
          </Form>
        )
      case 'confirmSignUp':
        return (
          <Form
            method='POST'
            onSubmit={e => handleSubmit(() => confirmSignUp(formState, updateFormType), e)}
          >
            <H2>Confirm Sign Up</H2>
            <ConfirmSignUp
              updateFormState={e => updateForm(e)}
            />
          </Form>
        )
      case 'signIn':
        return (
          <Form
            method='POST'
            onSubmit={e => handleSubmit(() => dispatch(signInUser(formState)), e)}
          >
            <H2>Sign In</H2>
            <SignIn
              updateFormState={e => updateForm(e)}
              disabled={!(formState.username && formState.password)}
            />
          </Form>
        )
      case 'forgotPassword':
        return (
          <Form
            method='POST'
            onSubmit={e => handleSubmit(() => forgotPassword(formState, updateFormType), e)}
          >
            <H2>Password Recovery</H2>
            <ForgotPassword
              updateFormState={e => updateForm(e)}
            />
          </Form>
        )
      case 'forgotPasswordSubmit':
        return (
          <Form
            method='POST'
            onSubmit={e => handleSubmit(() => forgotPasswordSubmit(formState, updateFormType), e)}
          >
            <H2>Password Recovery Submit</H2>
            <ForgotPasswordSubmit
              updateFormState={e => updateForm(e)}
            />
          </Form>
        )
      default:
        return null
    }
  }

  return (
    <>
      {renderForm()}
      { message &&
        <p style={{textAlign: 'center', color: 'white', fontWeight: 700, backgroundColor: 'darkRed', padding: '1em'}}>
          {message}
        </p>
      }
      { formType === 'signUp' && (
          <p style={styles.toggleForm}>
            Already have an account? <span
            style={styles.anchor}
            onClick={() => updateFormType('signIn')}
          >Sign In</span>
          </p>
        )
      }
      {
        formType === 'signIn' && (
          <>
            <p style={styles.toggleForm}>
              Need an account? <span
              style={styles.anchor}
              onClick={() => updateFormType('signUp')}
            >Sign Up</span>
            </p>
            <p style={{ ...styles.toggleForm, ...styles.resetPassword}}>
              Forget your password? <span
              style={styles.anchor}
              onClick={() => updateFormType('forgotPassword')}
            >Reset Password</span>
            </p>
          </>
        )
      }
    </>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 150,
    justifyContent: 'center',
    alignItems: 'center'
  },
  input: {
    height: 45,
    marginTop: 8,
    width: 300,
    maxWidth: 300,
    padding: '0px 8px',
    fontSize: 16,
    outline: 'none',
    border: 'none',
    borderBottom: '2px solid rgba(0, 0, 0, .3)'
  },
  toggleForm: {
    fontWeight: '600',
    padding: '0px 25px',
    marginTop: '15px',
    marginBottom: 0,
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.6)'
  },
  resetPassword: {
    marginTop: '5px',
  },
  anchor: {
    color: '#006bfc',
    cursor: 'pointer'
  }
}

export { styles, AuthForm as default }